import React from "react";
import Button from "../Button";

type Props = Pick<React.ComponentProps<typeof Button>, "children" | "onClick" | "disabled"> & {
  claim?: boolean;
  gift?: boolean;
};

// Synaps 9720:1986 and 9720:2311: use the exported button layers directly.
export default function WheelButton({ children, claim, gift, ...props }: Props) {
  return <Button {...props} type="button" className={`luck-action-button${claim ? " luck-action-claim" : ""}`}>
    <img className="luck-action-art" src={`/assets/images/wheel/events/${claim ? "claim-button" : "spin-button"}.png`} alt="" />
    <span className="luck-action-label">{children}</span>
    {gift && <span className="luck-action-gift" aria-hidden="true"><img src="/assets/images/wheel/events/spin-gift.png" alt="" /></span>}
  </Button>;
}
